import { extname } from 'path';

import { rejectUploadsAction, type Upload } from '@air/redux-uploader';

import { containsRestrictedPathChars } from '~/utils/FileUtils';

export type InputFile = Upload['file'];

export type RejectionReason = 'unsupported' | 'empty' | 'noExtension';

export const getSortedFilesAndMetadata = (
  acceptedFiles: InputFile[],
): {
  emptyFiles: InputFile[];
  filesWithNoExtension: InputFile[];
  filesWithRestrictedChars: InputFile[];
  files: InputFile[];
  totalSize: number;
} => {
  const emptyFiles: InputFile[] = [];
  const filesWithNoExtension: InputFile[] = [];
  const filesWithRestrictedChars: InputFile[] = [];
  const files: InputFile[] = [];
  let totalSize = 0;

  acceptedFiles.forEach((file) => {
    if (!file.size) {
      emptyFiles.push(file);
    } else if (!extname(file.name)) {
      filesWithNoExtension.push(file);
    } else if (containsRestrictedPathChars(file.name)) {
      filesWithRestrictedChars.push(file);
      totalSize += file.size;
    } else {
      files.push(file);
      totalSize += file.size;
    }
  });

  return {
    emptyFiles,
    files,
    totalSize,
    filesWithNoExtension,
    filesWithRestrictedChars,
  };
};

export const mapWithReason = (reason: RejectionReason) => (files: InputFile[]) =>
  files.map(({ name }) => ({ name, reason }));

export const handleRejectedFiles = ({
  rejectedFiles,
  emptyFiles,
  filesWithNoExtension,
}: {
  rejectedFiles: InputFile[];
  emptyFiles: InputFile[];
  filesWithNoExtension: InputFile[];
}) => {
  return rejectUploadsAction({
    files: [
      ...mapWithReason('unsupported')(rejectedFiles),
      ...mapWithReason('empty')(emptyFiles),
      ...mapWithReason('noExtension')(filesWithNoExtension),
    ],
  });
};
